import React, { useState } from 'react';
import '../styles/pages/MulticolorPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const MulticolorPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const multicolorTypes = [
    {
      id: 1,
      title: "Envelope Printing",
      icon: "✉️",
      description: "Professional envelope printing with vibrant multicolor designs. Perfect for business correspondence and marketing materials.",
      features: [
        "High-quality multicolor printing",
        "Custom sizes and shapes",
        "Security features available",
        "Bulk printing discounts",
        "Quick turnaround",
        "Premium paper options"
      ],
      specifications: {
        material: "Premium paper, various GSM",
        thickness: "80-120 GSM",
        width: "Standard and custom sizes",
        durability: "Standard envelope durability",
        applications: "Business correspondence, invitations"
      },
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=500&h=350&fit=crop", // Envelope image
      color: "#10b981",
      bestFor: ["Business letters", "Invitations", "Marketing mail", "Official documents"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Pamphlet/Flyers Printing",
      icon: "📄",
      description: "Eye-catching pamphlet and flyer printing in full multicolor. Ideal for promotions, events, and marketing campaigns.",
      features: [
        "Full-color printing",
        "Various paper stocks",
        "Custom folding options",
        "High-resolution graphics",
        "Bulk quantity pricing",
        "Fast production"
      ],
      specifications: {
        material: "Glossy/matte paper",
        thickness: "100-200 GSM",
        width: "A4, A5, custom sizes",
        durability: "Standard paper durability",
        applications: "Promotions, events, information"
      },
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=350&fit=crop", // Flyer image
      color: "#f59e0b",
      bestFor: ["Event promotions", "Product launches", "Local advertising", "Information distribution"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Brochure Printing",
      icon: "📖",
      description: "Professional brochure printing with stunning multicolor designs. Perfect for corporate presentations and detailed marketing materials.",
      features: [
        "Multicolor printing excellence",
        "Professional folding",
        "High-quality binding",
        "Custom layouts",
        "Premium finishes",
        "Large format options"
      ],
      specifications: {
        material: "Art paper, cardstock",
        thickness: "150-300 GSM",
        width: "A4, A3, custom",
        durability: "Enhanced durability",
        applications: "Corporate brochures, catalogs"
      },
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=350&fit=crop", // Brochure image
      color: "#3b82f6",
      bestFor: ["Corporate presentations", "Product catalogs", "Service information", "Company profiles"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 4,
      title: "Letter Head Printing",
      icon: "📝",
      description: "Elegant letterhead printing with multicolor branding. Essential for professional business communication and correspondence.",
      features: [
        "Multicolor logo printing",
        "Professional layouts",
        "Watermark options",
        "Security features",
        "Bulk printing",
        "Custom designs"
      ],
      specifications: {
        material: "Premium letterhead paper",
        thickness: "80-100 GSM",
        width: "A4, letter size",
        durability: "Standard paper",
        applications: "Business letters, memos"
      },
      image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=500&h=350&fit=crop", // Letterhead image
      color: "#ef4444",
      bestFor: ["Business letters", "Official correspondence", "Professional documents", "Company stationery"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="multicolor-printing-page">
      <HeroSection
        heroTitle="Multicolor Printing Services"
        heroSubtitle="Bring your ideas to life with our vibrant multicolor printing solutions. From envelopes to brochures, we deliver exceptional quality and creativity."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={multicolorTypes}
        title="Our Premium Multicolor Printing Solutions"
        subtitle="Bring your ideas to life with our vibrant multicolor printing solutions. From envelopes to brochures, we deliver exceptional quality and creativity."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={multicolorTypes.map(multicolorType => ({
          id: multicolorType.id,
          title: multicolorType.title,
          icon: multicolorType.icon,
          gallery: multicolorType.portfolio?.gallery || []
        }))}
        title="Our Multicolor Printing Portfolio"
        subtitle="Explore our premium multicolor printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default MulticolorPrinting;
